<template>
  <div>    
    <b-overlay :show="isCropping" rounded="sm" >
    <input
      v-if="false"
      ref="input"
      type="file"
      name="image"
      accept="image/*"      
      @change="setImage" />

    <div class="content">
      <section class="cropper-area">
        <b-row>
            <b-col md="8">
              <div class="img-cropper">
                <vue-cropper
                  ref="cropper"
                  :src="imgSrc"
                  :aspect-ratio="aspectRatio"
                  :zoomOnTouch="true"
                  :zoomOnWheel="true"
                  preview=".preview" />
              </div>
            </b-col>
            <b-col md="4">
              <div>
                <b-form-group label="Select Clipping">
                  <b-form-radio v-model="selectedMode" aria-describedby="Square" name="clip-radios" value="square">Square</b-form-radio>
                  <b-form-radio v-model="selectedMode" aria-describedby="rectangle" name="clip-radios" value="rectangle">Rectangle</b-form-radio>
                </b-form-group>
              </div>
              <div class="actions">
                <b-button variant="link" size="sm" borderless @click="zoom(0.2)"
                                    v-b-tooltip.hover title="Zoom In">
                    <b-icon icon="zoom-in" variant="primary"></b-icon>
                </b-button>
                <b-button variant="link" size="sm" borderless @click="zoom(-0.2)"
                                    v-b-tooltip.hover title="Zoom Out">
                    <b-icon icon="zoom-out" variant="primary"></b-icon>
                </b-button>
                
                <br/>

                <b-button variant="link" size="sm" borderless @click="move(-10, 0)"
                                    v-b-tooltip.hover title="Move Left">
                    <b-icon icon="arrow-left-square" variant="secondary"></b-icon>
                </b-button>
                <b-button variant="link" size="sm" borderless @click="move(10, 0)"
                                    v-b-tooltip.hover title="Move Right">
                    <b-icon icon="arrow-right-square" variant="secondary"></b-icon>
                </b-button>
                <b-button variant="link" size="sm" borderless @click="move(0, -10)"
                                    v-b-tooltip.hover title="Move Up">
                    <b-icon icon="arrow-up-square" variant="secondary"></b-icon>
                </b-button>
                <b-button variant="link" size="sm" borderless @click="move(0, 10)"
                                    v-b-tooltip.hover title="Move Down">
                    <b-icon icon="arrow-down-square" variant="secondary"></b-icon>
                </b-button>
                
                <br/>

                <b-button variant="link" size="sm" borderless @click="rotate(90)"
                                    v-b-tooltip.hover title="Rotate +90deg">
                    <b-icon icon="arrow-clockwise" variant="success"></b-icon>
                </b-button>
                <b-button variant="link" size="sm" borderless @click="rotate(-90)"
                                    v-b-tooltip.hover title="Rotate -90deg">
                    <b-icon icon="arrow-counterclockwise" variant="success"></b-icon>
                </b-button>

                <br/>

                <b-button ref="flipX" variant="link" size="sm" borderless @click="flipX"
                                    v-b-tooltip.hover title="Flip X">
                    <b-icon icon="distribute-horizontal" variant="info"></b-icon>
                </b-button>
                <b-button ref="flipY" variant="link" size="sm" borderless @click="flipY"
                                    v-b-tooltip.hover title="Flip Y">
                    <b-icon icon="distribute-vertical" variant="info"></b-icon>
                </b-button>
                            
                <br/>

                <b-button variant="link" size="sm" borderless @click="reset"
                                    v-b-tooltip.hover title="Reset">
                    <b-icon icon="bootstrap-reboot" variant="danger"></b-icon>
                </b-button>

                <br/>

                <b-button size="sm" borderless @click="saveCropData"
                                    v-b-tooltip.hover title="Save" variant="success">
                    <b-icon icon="upload" ></b-icon>
                    Save
                </b-button>

                <a
                  href="#"
                  role="button" v-if="false"
                  @click.prevent="cropImage">
                  Crop
                </a>
                <a
                  href="#"
                  role="button" v-if="false"
                  @click.prevent="getData">
                  Get Data
                </a>
                <a
                  href="#"
                  role="button" v-if="false"
                  @click.prevent="setData">
                  Set Data
                </a>
                
                <a
                  href="#"
                  role="button" v-if="false"
                  @click.prevent="setCropBoxData">
                  Set CropBox Data
                </a>
                <a
                  href="#"
                  role="button" v-if="false"
                  @click.prevent="showFileChooser">
                  Upload Image
                </a>
              </div>
              <div>
                <b-row>
                  <b-col md="6">
                    <b-img-lazy v-if="media && media.squareUrl"
                           thumbnail fluid :src="media.squareUrl" />
                  </b-col>
                  <b-col md="6">
                    <b-img-lazy v-if="media && media.rectangleUrl"
                           thumbnail fluid :src="media.rectangleUrl" />
                  </b-col>                  
                </b-row>
              </div>
            </b-col>
        </b-row>
        <textarea v-model="data" v-if="false"/>
      </section>
      
      <section class="preview-area" v-if="false">
        <p>Preview</p>
        <div class="preview" />
        <p v-if="false">Cropped Image</p>
        <div class="cropped-image" v-if="false">
          <img
            v-if="preview"
            :src="preview"
            alt="Cropped Image" />
          <div v-else class="crop-placeholder" />
        </div>
      </section>
    </div>
    </b-overlay>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  props: { 
            media : null ,
            autoScaleThumb : { type:String, default : "" },
            isCropping : { 
                            type: Boolean ,
                            default:false 
                        }
         },    
  components: {
    VueCropper,
  },
  data() {
    return {
      aspectRatio: 1 / 1,
      selectedMode:'square',
      preview:'',
      
      squareCrop:'',
      rectangleCrop:'',
      
      ciSquareCropData:null,
      ciRectangleCropData:null,

      squareCropData:null,
      rectangleCropData:null,

      imgSrc: '',
      cropImg: '',
      data: null,
    };
  },
  mounted(){
    this.$nextTick(()=> { this.fetchMedia();  })
  },
  watch: {
      media:{
        deep: true,
        immediate: true,
        handler() {
          if(this.media && this.media.thumbNail){
            this.fetchMedia();
          }
        }
      },
      selectedMode(newVal, oldVal) {
        if(oldVal === "square") {
          //this.squareCrop = this.$refs.cropper.getCroppedCanvas().toDataURL();
          this.squareCropData = this.$refs.cropper.getCropBoxData();
          this.ciSquareCropData = this.$refs.cropper.getData();
        } else {
          //this.rectangleCrop = this.$refs.cropper.getCroppedCanvas().toDataURL();
          this.rectangleCropData = this.$refs.cropper.getCropBoxData();
          this.ciRectangleCropData = this.$refs.cropper.getData();
        }

        if(newVal === "square") {
          this.aspectRatio = 1 / 1;
          this.$refs.cropper.setAspectRatio(this.aspectRatio)
          if (!this.squareCropData) return;
            this.$refs.cropper.setCropBoxData(this.squareCropData);
        } else {
          this.aspectRatio = 460 / 266;
          this.$refs.cropper.setAspectRatio(this.aspectRatio)          
          if (!this.rectangleCropData) return;
            this.$refs.cropper.setCropBoxData(this.rectangleCropData);
        }
      },
  },
  methods: {
    fetchMedia() {        
      fetch(this.media.thumbNail)
          .then(res => res.blob()) // Gets the response and returns it as a blob
          .then(blob => {
            if(blob) {
              this.imgSrc = URL.createObjectURL(blob);
              this.$refs.cropper.replace(this.imgSrc);
            } else {
              console.log("fetchMedia-blob", blob)
              this.fetchOrignialMedia();// Prefer Never Use this
            }
        }).catch(e=>{
          console.log("fetchMedia", e)
          this.fetchOrignialMedia();// Prefer Never Use this
        });
    },
    fetchOrignialMedia() {
      let {public_id, format} = this.media.original;
      let scalePath = `${this.autoScaleThumb}/${public_id}.${format}`;
      
      fetch(scalePath)
          .then(res => res.blob()) // Gets the response and returns it as a blob
          .then(blob => {
            if(blob) {
              this.imgSrc = URL.createObjectURL(blob);
              this.$refs.cropper.replace(this.imgSrc);
            } else {
              console.log("fetchOrignialMedia-blob", blob)
            }
        }).catch(e=>{
          console.log("fetchOrignialMedia", e)
        });
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
    },
    flipX() {
      const dom = this.$refs.flipX;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleX(scale);
      dom.setAttribute('data-scale', scale);
    },
    flipY() {
      const dom = this.$refs.flipY;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleY(scale);
      dom.setAttribute('data-scale', scale);
    },

    saveCropData() {
      let ciSquareCropData = this.ciSquareCropData;
      let ciRectangleCropData = this.ciRectangleCropData;      
      if(this.selectedMode === "square"){
        ciSquareCropData = this.$refs.cropper.getData();
      } else {
        ciRectangleCropData = this.$refs.cropper.getData();
      }    

      ciSquareCropData = ciSquareCropData ? this.tranformData(ciSquareCropData) : null;
      ciRectangleCropData = ciRectangleCropData ? this.tranformData(ciRectangleCropData) : null;

      let request = this.$deepCopy(this.media);
      let data = { ciSquareCropData : ciSquareCropData, ciRectangleCropData : ciRectangleCropData };
      request.tranformData = JSON.stringify(data);

      this.$emit('onCropData', request);
    },
    tranformData(cropData) {
      let cropRequest = [];
      
      let tranform = { }
          tranform.height = Math.floor(cropData.height)
          tranform.width = Math.floor(cropData.width)
          tranform.x = Math.floor(cropData.x)                    
          tranform.y = Math.floor(cropData.y)
          tranform.crop = "crop"

          tranform.angle =[]
          if(cropData.rotate) {
            tranform.angle.push(Math.floor(cropData.rotate));
          }
          if(cropData.scaleX === -1) {
            tranform.angle.push("hflip");
          }
          if(cropData.scaleY === -1) {
            tranform.angle.push("vflip");
          }

          cropRequest.push(tranform);
          
      return cropRequest;
    },

    getCropBoxData() {
      const cropData = this.$refs.cropper.getData() // Cropperjs method getData()
      let cropRequest = [];
      {
      let tranform = { }
          tranform.height = Math.floor(cropData.height)
          tranform.width = Math.floor(cropData.width)
          tranform.x = Math.floor(cropData.x)                    
          tranform.y = Math.floor(cropData.y)
          tranform.crop = "crop"

          tranform.angle =[]
          if(cropData.rotate) {
            tranform.angle.push(Math.floor(cropData.rotate));
          }
          if(cropData.scaleX === -1) {
            tranform.angle.push("hflip");
          }
          if(cropData.scaleY === -1) {
            tranform.angle.push("vflip");
          }

          cropRequest.push(tranform);
      }

      // this.preview = `https://res.cloudinary.com/dhara147/image/upload/c_crop,h_${Math.floor(cropData.height)},w_${Math.floor(cropData.width)},x_${Math.floor(cropData.x)},y_${Math.floor(cropData.y)},a_${Math.floor(cropData.rotate)}/v1610522595/menu/5f52f916beca044ca1916ac3/fP0vrE159WEOPgzTd2JeJ`

      this.data = JSON.stringify(cropRequest);
    },
    getData() {
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    reset() {
      this.$refs.cropper.reset();
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    setCropBoxData() {
      if (!this.data) return;
      this.$refs.cropper.setCropBoxData(JSON.parse(this.data));
    },
    setData() {
      if (!this.data) return;
      this.$refs.cropper.setData(JSON.parse(this.data));
    },
    setImage(e) {
      const file = e.target.files[0];
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    showFileChooser() {
      this.$refs.input.click();
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* body {
  font-family: Arial, Helvetica, sans-serif;
  width: 1024px;
  margin: 0 auto;
} */
input[type="file"] {
  display: none;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0 5px 0;
}
.header h2 {
  margin: 0;
}
.header a {
  text-decoration: none;
  color: black;
}
.content {
  display: flex;
  justify-content: space-between;
}
 .cropper-area {
  width: 100%;
} 
.actions {
  margin-top: 1rem;
}
.actions a {
  display: inline-block;
  padding: 5px 15px;
  background: #0062CC;
  color: white;
  text-decoration: none;
  border-radius: 3px;
  margin-right: 1rem;
  margin-bottom: 1rem;
}
textarea {
  width: 100%;
  height: 100px;
}
.preview-area {
  /* width: 307px; */
}
.preview-area p {
  font-size: 1.25rem;
  margin: 0;
  margin-bottom: 1rem;
}
.preview-area p:last-of-type {
  margin-top: 1rem;
}
.preview {
  width: 100%;
  height: calc(372px * (9 / 16));
  overflow: hidden;
}
.crop-placeholder {
  width: 100%;
  height: 200px;
  background: #ccc;
}
.cropped-image img {
  max-width: 100%;
}
</style>